"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireDefault(require("../common/Modal/Modal"));
var _APLabelWithText = _interopRequireDefault(require("../common/APLabelWithText"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("./ConfirmLimitOrderModalComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('limit-order-confirmation');
var ConfirmLimitOrderModalComponent = function ConfirmLimitOrderModalComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("order"),
    t = _useTranslation.t;
  var formObj = props.formObj,
    isOpen = props.isOpen,
    orderFormType = props.orderFormType,
    close = props.close,
    confirmOrder = props.confirmOrder,
    limitPrice = props.limitPrice,
    marketPrice = props.marketPrice,
    priceSymbol = props.priceSymbol;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: isOpen,
    title: t("Confirm Your Limit Order"),
    close: close,
    footer: {
      buttonText: t("Confirm Order"),
      onClick: function onClick() {
        return confirmOrder(orderFormType, formObj);
      }
    },
    customClass: bemClasses('modal')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses()
  }, /*#__PURE__*/_react["default"].createElement("h3", null, t("Please, confirm your Limit Order")), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('text')
  }, t("You are trying to place an order with `Limit price` below market price")), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t("Your Limit Price:"),
    text: "".concat(limitPrice, " ").concat(priceSymbol)
  }), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t("Market Price:"),
    text: "".concat(marketPrice, " ").concat(priceSymbol)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('text')
  }, t("Please confirm your order or exit"))));
};
ConfirmLimitOrderModalComponent.propTypes = {
  close: _propTypes["default"].func.isRequired,
  isOpen: _propTypes["default"].bool.isRequired,
  confirmOrder: _propTypes["default"].func.isRequired,
  limitPrice: _propTypes["default"].string.isRequired,
  marketPrice: _propTypes["default"].number.isRequired,
  priceSymbol: _propTypes["default"].string.isRequired,
  orderFormType: _propTypes["default"].string.isRequired,
  formObj: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = ConfirmLimitOrderModalComponent;